/*tslint:disable:class-name*/
import { ILocationService, IPromise } from 'angular';
import ActionDispatcherService from '../actions/core/action-dispatcher.service';
import { LanguageChangeAction } from '../actions/language.action';
import MobileService from './mobile.service';

export default class i18nProvider {
  constructor(
    private $translateProvider: angular.translate.ITranslateProvider
  ) {
    'ngInject';
  }

  public init(options) {
    this.$translateProvider
      .registerAvailableLanguageKeys(options.availableLanguages, {
        '*': 'tr',
        'de_*': 'de',
        'en_*': 'en',
        'ru_*': 'ru',
        'tr_*': 'tr'
      })
      .fallbackLanguage(options.fallbackLanguage || options.preferredLanguage)
      .useStaticFilesLoader({
        prefix: 'i18n/',
        suffix: '.json'
      })
      .determinePreferredLanguage()
      .useSanitizeValueStrategy('sanitizeParameters');
  }

  public $get(
    $translate,
    actionDispatcher: ActionDispatcherService,
    $filter,
    $cookies,
    config,
    $location: ILocationService,
    mobileService: MobileService
  ) {
    'ngInject';

    const storageKey = 'ui-language';
    const translateFilter = $filter('translate');

    _init();

    return {
      getAvailableLanguages,
      getCurrentLanguage,
      getTranslation,
      shareLanguage,
      useLanguage,
      getFallbackLanguage,
      cookieExists
    };

    function _init(): void {
      const language = $cookies.get(config.language.cookie) || 
        $location.search().language ||
        (mobileService.isMobile() && $translate.preferredLanguage()) 
      if (language) {
        $cookies.put(config.language.cookie, language.toLowerCase(), {
          domain: config.cookieDomain
        });
        _setLanguage(language.toLowerCase());
      }
    }

    function _setLanguage(language: string): IPromise<string> {
      return $translate.use(language);
    }

    function shareLanguage(language = getCurrentLanguage()): void {
      $cookies.put(config.language.cookie, language, {
        domain: config.cookieDomain
      });
    }

    function useLanguage(language: string): IPromise<string> {
      shareLanguage(language);
      return _setLanguage(language).then(currentLanguage => {
        actionDispatcher.dispatch(new LanguageChangeAction(currentLanguage, false));
        return currentLanguage;
      });
    }

    function getCurrentLanguage() {
      return (
        $translate.use() ||
        $translate.proposedLanguage() ||
        $translate.preferredLanguage()
      );
    }

    function getAvailableLanguages() {
      return $translate.getAvailableLanguageKeys();
    }

    function getTranslation(key: string, params?) {
      return translateFilter(key, params);
    }

    function getFallbackLanguage() {
      return $translate.fallbackLanguage();
    }

    function cookieExists() {
      return $cookies.get(config.language.cookie);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/i18n.provider.ts